<template>
  <div>
    <b-card>
      <div class="row">
        <div class="col-lg-12">
          <h4>Új emelő gép létrehozása</h4>
        </div>
      </div>
    </b-card>
    <form-wizard
      color="#3e74c7"
      :title="null"
      :subtitle="null"
      ref="wizard"
      :enable-finish-button="true"
      layout="vertical"
      finish-button-text="Létrehozás"
      next-button-text="Tovább"
      next-button-icon="fa fa-arrow-right"
      back-button-text="Vissza"
      class="wizard-vertical mb-3"
      @on-complete="create"
      tabindex="3"
    >

      <!-- account datails tab -->
      <tab-content title="Emelő gép adatai">
        <div class="row">
          <h5 class="col-lg-12 mb-0 pb-0">Emelő gép adatai</h5>
          <b-form-group
            label="Emelőgép megnevezése"
            label-for="name"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="name"
              v-model="name"
              type="text"
              placeholder="Emelőgép megnevezése"
            />
          </b-form-group>
          <b-form-group
            label="Gyártmány"
            label-for="brand"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="brand"
              v-model="brand"
              type="text"
              placeholder="Gyártmány"
            />
          </b-form-group>
          <b-form-group
            label="Típus"
            label-for="type"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="type"
              v-model="type"
              type="text"
              placeholder="Típus"
            />
          </b-form-group>
          <b-form-group
            label="Gyártási év"
            label-for="year_of_manufacture"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="year_of_manufacture"
              v-model="year_of_manufacture"
              type="number"
              placeholder="Gyártási év"
            />
          </b-form-group>
          <b-form-group
            label="Gyártási szám"
            label-for="manufacturing_number"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="manufacturing_number"
              v-model="manufacturing_number"
              type="text"
              placeholder="Gyártási szám"
            />
          </b-form-group>
          <b-form-group
            label="Aktuális üzemóra"
            label-for="current_hours"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="current_hours"
              v-model="current_hours"
              type="number"
              placeholder="Aktuális üzemóra"
            />
          </b-form-group>
          <b-form-group
            label="Szervíz intervallum"
            label-for="service_interval"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="service_interval"
              v-model="service_interval"
              type="number"
              placeholder="Szervíz intervallum"
            />
          </b-form-group>
        </div>

      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BFormGroup,
  BFormInput,
  BCard,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'

export default {
  components: {
    FormWizard,
    TabContent,
    BFormGroup,
    BFormInput,
    BCard,
  },
  data() {
    return {
      name: '',
      brand: '',
      type: '',
      year_of_manufacture: '',
      manufacturing_number: '',
      current_hours: '',
      service_interval: '',
    }
  },
  methods: {
    create() {
      axios({
        method: 'post',
        url: 'lifting-machine/create',
        data: {
          name: this.name,
          brand: this.brand,
          type: this.type,
          year_of_manufacture: this.year_of_manufacture,
          manufacturing_number: this.manufacturing_number,
          current_hours: this.current_hours,
          service_interval: this.service_interval,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then((response) => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sikeres létrehozás!',
            text: 'Az emelő gép sikeresen létrehozva.',
            variant: 'success',
          },
        })
        this.$router.push(`/lifting-machines/edit/${response.data.id}`)
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Hiba történt!',
            text: 'Az emelő gép létrehozása sikertelen.',
            variant: 'danger',
          },
        })
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
</style>